export default "__VITE_ASSET__7218482a__"